import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const SmoothGravelIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Smooth gravel - even distribution of small pebbles */}
    <path d="M3 18h18" />
    <circle cx="5" cy="15" r="1" />
    <circle cx="9" cy="14" r="1.2" />
    <circle cx="13" cy="15" r="1" />
    <circle cx="17" cy="14" r="1.3" />
    <circle cx="7" cy="11" r="0.8" />
    <circle cx="11" cy="10" r="1" />
    <circle cx="15" cy="11" r="0.9" />
    <circle cx="19" cy="10" r="1" />
  </svg>
);
